export default __webpack_public_path__ + "static/media/claned.f894f918.svg";